const issuesActions = {

  // DO_LIST_ISSUES
  DO_LIST_ISSUES: 'DO_LIST_ISSUES',
  doListIssues: () => ({
    type: issuesActions.DO_LIST_ISSUES
  }),

  DO_LIST_ISSUES_SUCCESS: 'DO_LIST_ISSUES_SUCCESS',
  doListIssuesSuccess: response => ({
    type: issuesActions.DO_LIST_ISSUES_SUCCESS,
    payload: response
  }),

  DO_LIST_ISSUES_FAILED: 'DO_LIST_ISSUES_FAILED',
  doListIssuesFailed: response => ({
    type: issuesActions.DO_LIST_ISSUES_FAILED,
    payload: response
  }),

  // DO_GET_ISSUE_DETAILS
  DO_GET_ISSUE_DETAILS: 'DO_GET_ISSUE_DETAILS',
  doGetIssueDetails: (hash, doneAction) => ({
    type: issuesActions.DO_GET_ISSUE_DETAILS,
    payload: hash
  }),

  DO_GET_ISSUE_DETAILS_SUCCESS: 'DO_GET_ISSUE_DETAILS_SUCCESS',
  doGetIssueDetailsSuccess: response => ({
    type: issuesActions.DO_GET_ISSUE_DETAILS_SUCCESS,
    payload: response
  }),

  DO_GET_ISSUE_DETAILS_FAILED: 'DO_GET_ISSUE_DETAILS_FAILED',
  doGetIssueDetailsFailed: response => ({
    type: issuesActions.DO_GET_ISSUE_DETAILS_FAILED,
    payload: response
  }),

  // DO_RESOLVE_ISSUE
  DO_RESOLVE_ISSUE: 'DO_RESOLVE_ISSUE',
  doResolveIssue: hash => ({
    type: issuesActions.DO_RESOLVE_ISSUE,
    payload: hash
  }),

  DO_RESOLVE_ISSUE_SUCCESS: 'DO_RESOLVE_ISSUE_SUCCESS',
  doResolveIssueSuccess: payload => ({
    type: issuesActions.DO_RESOLVE_ISSUE_SUCCESS,
    payload
  }),

  DO_RESOLVE_ISSUE_FAILED: 'DO_RESOLVE_ISSUE_FAILED',
  doResolveIssueFailed: payload => ({
    type: issuesActions.DO_RESOLVE_ISSUE_FAILED,
    payload
  }),

  DO_RESOLVE_ISSUE_RESET: 'DO_RESOLVE_ISSUE_RESET',
  doResolveIssueFailedReset: payload => ({
    type: issuesActions.DO_RESOLVE_ISSUE_RESET,
    payload
  })
}

export default issuesActions;



// WEBPACK FOOTER //
// ./src/redux/issues/actions.js